export default __webpack_public_path__ + "static/media/9.2e967b4a.webp";